import { useAppSpeciesSortOptions } from "@carnet/ui/composables/useAppSpeciesSortOptions";

export { SPECIES_SORT_VALUES } from "@carnet/ui/utils/speciesSort";
export type { SpeciesSort, SortOption } from "@carnet/ui/utils/speciesSort";

export function useSpeciesSortOptions() {
  const { data: profile } = useProfileData();
  return useAppSpeciesSortOptions(() => profile.value?.isNaturalist ?? false);
}
